import React from "react";

import { homeActions } from '../actions';
import { connect } from 'react-redux'
import { StudentDebt } from '../components/StudentDebt';
import { Birthdays} from '../components/Birthdays';



import './HomePage.css';

var homeService = require ('../api');
var viewActions = require ('store/view.actions');


// CALENDARIO
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment'
// const localizer = momentLocalizer(moment) ;
// const today = new Date();
// const myEventsList = [
//   {
//     id: 0,
//     title: 'All Day Event very long title',
//     allDay: true,
//     start: new Date(2022, 1, 4),
//     end: new Date(2022, 1, 5),
//   },
//   {
//       id: 2,
//       title: 'Happy Hour',
//       start: new Date(2022, 1, 3, 17, 0, 0, 0),
//       end: new Date(2022, 1, 3, 17, 30, 0, 0),
//       desc: 'Most important meal of the day',
//     } 
//   ];
// FIN CALENDARIO


var Utils = require ('Utils') ;

const isTutor = () => {
  return this.props.userRoles.indexOf("[FULL_CONFIG]")  !== -1 ;
}




class HomePage extends React.Component {

  componentDidMount() {
    this.props.setMainTitle("Hola " + this.props.user.name, [] );

    if ( this.props.user.user_type === 'STUDENT' ) {
      this.props.getMyDebt (this.props.token)
    }

    if (isTutor) {
      this.loadBirthdays( this.props.token , this.props.currentCalendarID) ;
      }

   }

  constructor(props) {
    super(props);
    this.state = {
      birthdays: []
    
    }

 }

  loadBirthdays = async (token, calendarID) => {
    let bd = await homeService.getMyCourseBirthdays ( token , calendarID) 

    this.setState({ birthdays: bd }) ;

  }

  render() {
    return (
      <>
        <div className="content">
          {isTutor && this.state.birthdays &&  this.state.birthdays.length>0 &&
              <Birthdays 
                personas={this.state.birthdays}
              />
            }

          {!this.props.user.image &&
            <div className="alert-text alert alert-danger " >
              {Utils.capitalize(this.props.user.name)}, aún validaste tus datos ni cargaste la foto de perfil. Estos datos y foto son los que verán todos los usuarios de la plataforma, profesores, directivos
              y alumnos. Ingresa a <a href="/admin/my-profile" class="alert-link">mis datos</a> para hacerlo.
            </div>
          }
          {this.props.myDebts && this.props.myDebts.length > 0 &&
            <StudentDebt 
              invoices={this.props.myDebts}
            />
          }
            {/* <AttendanceListCard
                attendanceList={[]} // {this.props.studentAttendance}
                persona={this.props.user}
              /> */}
          {/* <Calendar
              localizer={localizer}
              events={myEventsList}
              startAccessor="start"
              endAccessor="end"
              step={30}
              defaultView="work_week"
              views={[ 'work_week']}
              // style={{ height: 500 }}
              min={ new Date( today.getFullYear(), today.getMonth(), today.getDate(), 7)}
              max={ new Date( today.getFullYear(), today.getMonth(), today.getDate(), 19)}

          />     */}
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        user: state.auth.session.user,
        currentCalendarID: state.school.currentCalendarID,
        userRoles: state.auth.session.userRoles,
        view: state.view,
        token: state.auth.session.jwt_token,
        myDebts: state.home.myDebts
      }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
      setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
      },
      getMyDebt: (token) => {
        dispatch(homeActions.getMyDebt(token)) ;
      }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(HomePage);

